module.exports = __webpack_public_path__ + "img/oxford-arts-logo.995ec7d0.jpg";